const RoversSvg = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={40.094} height={36.448} viewBox='0 0 40.094 36.448' {...props}>
    <g data-name='Group 10578'>
      <path
        fill='currentColor'
        d='M6.224 14.368v-1.416l19.14-5.094.797 3.488 7.916-.01 4.644 2.569-.33 3.872a6.1 6.1 0 0 0-1.665-1.201 6 6 0 0 0-8.006 2.76 5.554 5.554 0 0 0-.537 1.826 4.581 4.581 0 0 0-.056.987l-.005.01c.011.205.027.401.053.591l-3.156-.005a4.021 4.021 0 0 0 .046-.626 5.043 5.043 0 0 0-.053-.957 5.975 5.975 0 0 0-3.309-4.583 5.98 5.98 0 0 0-7.801 2.412 5.924 5.924 0 0 0-2.574-2.41 5.993 5.993 0 0 0-8.002 2.75 5.945 5.945 0 0 0-.548 3.425l-1.57.002 2.403-7.98Zm18.338-2.882-.381-1.668L8.38 14.022 8.482 14Z'
        data-name='Path 29455'
      />
      <g data-name='Ellipse 11'>
        <path
          fill='currentColor'
          d='M32.349 25.56a4.016 4.016 0 0 0 5.364-1.848 4.016 4.016 0 0 0-1.85-5.363A4.016 4.016 0 0 0 30.5 20.2a4.016 4.016 0 0 0 1.849 5.362Z'
          data-name='Path 29460'
        />
      </g>
      <g data-name='Ellipse 13'>
        <path
          fill='currentColor'
          d='M17.264 25.702a4.167 4.167 0 0 0 5.565-1.92 4.167 4.167 0 0 0-1.919-5.564 4.167 4.167 0 0 0-5.565 1.918 4.168 4.168 0 0 0 1.919 5.566Z'
          data-name='Path 29461'
        />
      </g>
      <g data-name='Ellipse 15'>
        <path
          fill='currentColor'
          d='M6.955 25.555a4.007 4.007 0 0 0 5.348-1.844 4.007 4.007 0 0 0-1.844-5.348 4.008 4.008 0 0 0-5.348 1.844 4.008 4.008 0 0 0 1.844 5.348Z'
          data-name='Path 29462'
        />
      </g>
    </g>
  </svg>
);
export default RoversSvg;
